"use client"
import React from 'react';
import { FiClock } from 'react-icons/fi';

const ReadingTime = ({ text }) => {
  // Calculate reading time
  const wordsPerMinute = 200; // Average reading speed
  const words = text.trim().split(/\s+/).length;
  const minutes = Math.ceil(words / wordsPerMinute);
  
  return (
    <div className="flex items-center text-gray-600">
      <FiClock className="mr-2" />
      <span>{minutes} min read</span>
    </div>
  );
};

export default ReadingTime; 